import { ChangeDetectionStrategy, Component, EventEmitter, Output } from "@angular/core";

@Component({
	selector: "tax-declaration-prompt",
	templateUrl: "./tax-declaration-prompt.component.html",
	styleUrls: ["./tax-declaration-prompt.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaxDeclarationPromptComponent {
	@Output() public readonly onButtonClicked = new EventEmitter<void>();

	public onOptionClick(): void {
		this.onButtonClicked.emit();
	}
}
